"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var FunFactsSetting = function FunFactsSetting(_ref) {
  var funFacts = _ref.funFacts,
      showFunFacts = _ref.showFunFacts,
      isLoading = _ref.isLoading,
      errors = _ref.errors,
      onSave = _ref.onSave;

  var _useState = (0, _react.useState)(funFacts),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      localFunFacts = _useState2[0],
      setLocalFunFacts = _useState2[1];

  var _useState3 = (0, _react.useState)(showFunFacts),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isShowFunFacts = _useState4[0],
      setIsShowFunFacts = _useState4[1];

  var toggleShowFunFacts = (0, _react.useCallback)(function () {
    return setIsShowFunFacts(!isShowFunFacts);
  }, [isShowFunFacts]);
  var saveUserName = (0, _react.useCallback)(function () {
    onSave({
      funFacts: localFunFacts,
      showFunFacts: isShowFunFacts
    });
  }, [onSave, localFunFacts, isShowFunFacts]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 10,
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    mt: 3,
    mr: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.TextAreaField, {
    name: "funFacts",
    label: "What are some fun facts about yourself?",
    placeholder: "What are some fun facts about yourself?",
    fullWidth: true,
    value: localFunFacts,
    disabled: isLoading,
    errors: errors,
    onChange: function onChange(e) {
      return setLocalFunFacts(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    mr: 3
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, null, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: isShowFunFacts,
      onChange: toggleShowFunFacts,
      value: "enabled",
      color: "primary"
    }),
    label: "Display in gift experience landing pages"
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    onClick: saveUserName,
    disabled: isLoading
  }, "Save"))));
};

FunFactsSetting.propTypes = {
  funFacts: _propTypes.default.string.isRequired,
  showFunFacts: _propTypes.default.bool.isRequired,
  isLoading: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object,
  onSave: _propTypes.default.func.isRequired
};
FunFactsSetting.defaultProps = {
  isLoading: false,
  errors: {}
};
var _default = FunFactsSetting;
exports.default = _default;